import join from "lodash/join";
class Uuid7Generator {
    static timeNs() {
        const ticks = new Date().getTime() * Uuid7Generator.ticksPerMillisecond;
        return 100 * ticks;
    }
    static rand(a, b) {
        return (a + ((b - a + 1) * crypto.getRandomValues(new Uint32Array(1))[0]) / 2 ** 32) | 0;
    }
    static hexToChar(a) {
        a &= 0xf;
        return String.fromCharCode(a > 9 ? a - 10 + 0x61 : a + 0x30);
    }
    static hexsToChars(guidChars, offset, a, b, hex) {
        if (hex) {
            guidChars[offset++] = "0";
            guidChars[offset++] = "x";
        }
        guidChars[offset++] = Uuid7Generator.hexToChar(a >> 4);
        guidChars[offset++] = Uuid7Generator.hexToChar(a);
        if (hex) {
            guidChars[offset++] = ",";
            guidChars[offset++] = "0";
            guidChars[offset++] = "x";
        }
        guidChars[offset++] = Uuid7Generator.hexToChar(b >> 4);
        guidChars[offset++] = Uuid7Generator.hexToChar(b);
        return offset;
    }
    static bytesToGuidString(a, b, c, d) {
        const guidChars = new Array(36);
        let offset = 0;
        offset = Uuid7Generator.hexsToChars(guidChars, offset, a >> 24, a >> 16, false);
        offset = Uuid7Generator.hexsToChars(guidChars, offset, a >> 8, a, false);
        guidChars[offset++] = "-";
        offset = Uuid7Generator.hexsToChars(guidChars, offset, b >> 8, b, false);
        guidChars[offset++] = "-";
        offset = Uuid7Generator.hexsToChars(guidChars, offset, c >> 8, c, false);
        guidChars[offset++] = "-";
        offset = Uuid7Generator.hexsToChars(guidChars, offset, d[0], d[1], false);
        guidChars[offset++] = "-";
        offset = Uuid7Generator.hexsToChars(guidChars, offset, d[2], d[3], false);
        offset = Uuid7Generator.hexsToChars(guidChars, offset, d[4], d[5], false);
        offset = Uuid7Generator.hexsToChars(guidChars, offset, d[6], d[7], false);
        return join(guidChars, "");
    }
    static guid() {
        const uuidVersion = 7;
        const uuidVariant = 0b10;
        const maxSeqValue = 0x3fff;
        const ns = Uuid7Generator.timeNs();
        const fr = 16 * 10 ** 9;
        const x = Math.floor(ns / fr);
        const rest1 = (ns % fr) * 2 ** 16;
        const y = Math.floor(rest1 / fr);
        const rest2 = (rest1 % fr) * 2 ** 12;
        const z = Math.floor(rest2 / fr);
        let seq = 0;
        if (x === Uuid7Generator._x_asOf &&
            y === Uuid7Generator._y_asOf &&
            z === Uuid7Generator._z_asOf) {
            if (Uuid7Generator._seq_asOf < maxSeqValue)
                Uuid7Generator._seq_asOf += 1;
        }
        else {
            Uuid7Generator._seq_asOf = 0;
            Uuid7Generator._x_asOf = x;
            Uuid7Generator._y_asOf = y;
            Uuid7Generator._z_asOf = z;
        }
        seq = Uuid7Generator._seq_asOf;
        const last8Bytes = new Array();
        last8Bytes.push((uuidVariant * 2 ** 6) | (seq >> 8));
        last8Bytes.push(seq & 0xff);
        for (let i = 0; i < 6; i++) {
            last8Bytes.push(Uuid7Generator.rand(0, 256));
        }
        return Uuid7Generator.bytesToGuidString(x, y, uuidVersion * 2 ** 12 + (z & 0xffff), last8Bytes);
    }
}
Uuid7Generator._x = 0;
Uuid7Generator._y = 0;
Uuid7Generator._z = 0;
Uuid7Generator._seq = 0;
Uuid7Generator._x_asOf = 0;
Uuid7Generator._y_asOf = 0;
Uuid7Generator._z_asOf = 0;
Uuid7Generator._seq_asOf = 0;
Uuid7Generator.ticksPerMillisecond = 10000;
Uuid7Generator.validator = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
Uuid7Generator.isValid = (value) => Uuid7Generator.validator.test(value);
export default Uuid7Generator;
